import { createGlobalStyle } from "styled-components";
import theme from "./theme";

export default createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500&display=swap');

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  body, input, button {
    font-family: 'Poppins', sans-serif; /* Corrigido o nome da fonte aqui */
    font-size: 14px; /* Defina o tamanho da fonte aqui */
    background-color: ${theme.colors.secondary};
    color:${theme.colors.texto};
  }

  button {
    cursor: pointer;
    border: 0;
  }
  
  a {
    text-decoration: none;
    color: black;
  }
`;
